import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Accordion from "react-bootstrap/Accordion";
import { Form } from "react-bootstrap";
import { HasPermission } from "../../services/hasPermission";

import { checkExisting } from "./function";

const RolePermission = ({
  user,
  designationId,
  saveMasterRolePermissionsPath,
  dispatch,
  commonSaveData,
  initialData,
  handleModalClose1,
  staffId,
  isPopup,
  isEdit,
}) => {
  const [permissions, setPermissions] = useState(initialData);
  const [selectAll, setSelectAll] = useState(false);

  // EXISTING FUNCTION - Global Select All
  const toggleSelectAll = () => {
    const newVal = selectAll ? "0" : "1";
    const updated = permissions.map((row) => {
      const updatedRow = { ...row };
      [
        "view",
        "create",
        "edit",
        "delete",
        "export",
        "approve",
        "reject",
      ].forEach((key) => {
        if (updatedRow[key] !== null && updatedRow[key] !== undefined) {
          updatedRow[key] = newVal;
        }
      });
      return updatedRow;
    });
    setPermissions(updated);
    setSelectAll(!selectAll);
  };
  const [saveData, setSaveData] = useState({
    userId: user.user_id,
    designationId: designationId,
  });

  // EXISTING FUNCTION - Save
  const savePermission = () => {
    const data = {
      path: saveMasterRolePermissionsPath,
      data: {
        staffId: staffId,
        designationId: saveData.designationId,
        userId: user.user_id,
        permissions: permissions,
      },
    };
    dispatch(commonSaveData(data));
  };

  const handleMainModuleCheckChange = (mainModuleId, isChecked) => {
    const children = permissions.filter((row) => row.parentId == mainModuleId);

    if (children.length > 0) {
      // ✅ Children present ➔ Update children
      setPermissions((prev) =>
        prev.map((row) => {
          if (row.parentId == mainModuleId) {
            const updatedRow = { ...row };
            [
              "view",
              "create",
              "edit",
              "delete",
              "export",
              "approve",
              "reject",
            ].forEach((key) => {
              if (updatedRow[key] !== null && updatedRow[key] !== undefined) {
                updatedRow[key] = isChecked ? "1" : "0";
              }
            });
            return updatedRow;
          }
          return row;
        })
      );
    } else {
      // ✅ No children ➔ Update parent itself
      setPermissions((prev) =>
        prev.map((row) => {
          if (row.moduleId == mainModuleId) {
            const updatedRow = { ...row };
            [
              "view",
              "create",
              "edit",
              "delete",
              "export",
              "approve",
              "reject",
            ].forEach((key) => {
              if (updatedRow[key] !== null && updatedRow[key] !== undefined) {
                updatedRow[key] = isChecked ? "1" : "0";
              }
            });
            return updatedRow;
          }
          return row;
        })
      );
    }
  };

  const isMainModuleAllChecked = (mainModuleId) => {
    const children = permissions.filter((row) => row.parentId == mainModuleId);

    if (children.length > 0) {
      // ✅ Children present
      return (
        children.length > 0 &&
        children.every((child) =>
          [
            "view",
            "create",
            "edit",
            "delete",
            "export",
            "approve",
            "reject",
          ].every((key) => {
            if (child[key] === null || child[key] === undefined) return true;
            return child[key] === "1";
          })
        )
      );
    } else {
      // ✅ No children ➔ Check parent itself
      const parent = permissions.find((row) => row.moduleId == mainModuleId);
      if (!parent) return false;

      const availableField = [
        "view",
        "create",
        "edit",
        "delete",
        "export",
        "approve",
        "reject",
      ].find((key) => parent[key] !== null && parent[key] !== undefined);
      if (!availableField) return false;

      return parent[availableField] === "1";
    }
  };

  // NEW FUNCTION - SubModule Field Change
  const handleFieldChange = (moduleId, field, checked) => {
    setPermissions((prev) =>
      prev.map((row) =>
        row.moduleId == moduleId
          ? {
              ...row,
              [field]: checked ? "1" : "0",
            }
          : row
      )
    );
  };

  return (
    <>
      <div className="dialog-title mb-2">
        <div className="dialog-title-icon">
          <span className="close-icon" onClick={handleModalClose1}>
            X
          </span>
          <span className="title">Role Permission</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          {
            isEdit && <>
            <button
            onClick={toggleSelectAll}
            style={{
              background: selectAll ? "#d63031" : "#00b894",
              color: "white",
              padding: "6px 12px",
              border: "none",
              borderRadius: "12px",
              fontWeight: "bold",
              fontSize: "13px",
            }}
          >
            {selectAll ? "Unselect All" : "Select All"}
          </button>
          {HasPermission("User Permission", "edit")}
          <button className="universal-btn" onClick={savePermission}>
            Save Changes
          </button>
            </>
          }
          
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          width: "calc(100% - 50px)",
          height: "calc(100vh - 90px)",
          marginTop: "5px",
          overflow: "auto",
          // backgroundColor: "transparent",
          borderRadius: "12px",
        }}
      >
        <Accordion
          defaultActiveKey="0"
          style={{ backgroundColor: "transparent", marginBottom: "150px" }}
        >
          {permissions.map((row, idx) => {
            return (
              row.isMainModule == "1" && (
                <Accordion.Item
                  eventKey={idx}
                  style={{
                    backgroundColor: "transparent",
                    border: "1px solid #5f5f5f",
                    padding: "0",
                    marginBottom: "100px",
                  }}
                  key={idx}
                  className="mb-2"
                >
                  <Accordion.Header>
                    <div className="d-flex align-items-center justify-content-start gap-2">
                      <input
                        type="checkbox"
                        className="custom-checkbox"
                        checked={isMainModuleAllChecked(row.moduleId)}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMainModuleCheckChange(
                            row.moduleId,
                            e.target.checked
                          );
                        }}
                        style={{ position: "relative", top: "1px" }}
                      />

                      <div
                        style={{
                          flex: 1,
                          cursor: "pointer",
                        }}
                        className="color-white"
                        onClick={(e) => {
                          // Manually trigger toggle
                          const button = e.currentTarget
                            .closest(".accordion-item")
                            ?.querySelector(".accordion-button");
                          if (button) button.click();
                        }}
                      >
                        {row.moduleName}
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body
                    style={{
                      borderTop: "1px solid #2b2b2c",
                      paddingBottom: "100px",
                      marginBottom: "100px",
                    }}
                  >
                    <table className="role-table">
                      {checkExisting(permissions, row.moduleId) ? (
                        <thead>
                          <tr>
                            <th>Module Name</th>
                            <th className="text-align-center">View</th>
                            <th className="text-align-center">Create</th>
                            <th className="text-align-center">Edit</th>
                            <th className="text-align-center">Delete</th>
                            <th className="text-align-center">Export</th>
                            <th className="text-align-center">Approve</th>
                            <th className="text-align-center">Reject</th>
                          </tr>
                        </thead>
                      ) : (
                        <span className="color-gray">No Sub Module Found!</span>
                      )}

                      <tbody>
                        {permissions.map((r1, idx1) => {
                          return (
                            row.moduleId == r1.parentId && (
                              <tr key={idx1}>
                                <td>{r1.moduleName}</td>
                                {[
                                  "view",
                                  "create",
                                  "edit",
                                  "delete",
                                  "export",
                                  "approve",
                                  "reject",
                                ].map((key) =>
                                  r1.isMainModule == "1" ? (
                                    <td
                                      key={key}
                                      className="text-align-center"
                                    ></td>
                                  ) : r1[key] === null ||
                                    r1[key] === "null" ||
                                    r1[key] === "" ||
                                    r1[key] === "undefined" ||
                                    r1[key] === undefined ? (
                                    <td key={key} className="text-align-center">
                                      <span className="color-gray">-</span>
                                    </td>
                                  ) : (
                                    <td key={key} className="text-align-center">
                                      <input
                                        type="checkbox"
                                        className="custom-checkbox"
                                        checked={r1[key] === "1"}
                                        onChange={(e) =>
                                          handleFieldChange(
                                            r1.moduleId,
                                            key,
                                            e.target.checked
                                          )
                                        }
                                      />
                                    </td>
                                  )
                                )}
                              </tr>
                            )
                          );
                        })}
                      </tbody>
                    </table>
                  </Accordion.Body>
                </Accordion.Item>
              )
            );
          })}
        </Accordion>
      </div>
    </>
  );
};

export default RolePermission;
